import React from "react";

export default function AdminTenants() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Tenants</h1>
        <p className="text-zinc-400 mt-1">Gerencie todos os tenants</p>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 text-center">
        <p className="text-zinc-400">Página em desenvolvimento</p>
      </div>
    </div>
  );
}
